import React, { useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import logo from "../images/site_logo.png";
import { Auth } from "aws-amplify";
import { UserContext } from "../App";
import { API, graphqlOperation } from "aws-amplify";
import { createTaxReturn } from "../graphql/mutations";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#cccccc",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  logo: {
    maxWidth: 200,
    marginRight: "10px",
  },
}));

/*
<img src={logo} alt="Mantra Tax!" className={classes.logo} />
style={{ backgroundColor: "white" }}
*/
export default function MantraAppBar() {
  const classes = useStyles();
  const { user, setUser, signOutState, setSignOutState, taxReturn, setTaxReturn } = useContext(UserContext);

  const getTaxReturnSimple = /* GraphQL */ `
    query GetTaxReturn($email: String!, $taxYear: String!) {
      getTaxReturn(email: $email, taxYear: $taxYear) {
        id
        email
        taxYear
      }
    }
  `;

  useEffect(() => {
    let tmpTaxReturn = null;
    console.log("Tax Return in MantraAppBar useEffect1:", taxReturn);
    if (!taxReturn) {
      tmpTaxReturn = registerTaxReturn();
    }
    console.log("Tax Return in MantraAppBar useEffect2:", tmpTaxReturn);
  }, [taxReturn]);

  async function registerTaxReturn() {
    const userId = user.attributes.sub;
    console.log("User when registering new Tax Return:", user);
    const queryInput = {
      email: user.attributes.email,
      taxYear: "2020",
    };

    const { data } = await API.graphql(graphqlOperation(getTaxReturnSimple, queryInput));
    console.log("Check for existing taxReturn:", data);

    // if we can't get a user (meaning the user hasn't been registered before), then we execute registerUser
    if (!data.getTaxReturn) {
      try {
        const input = {
          id: userId,
          email: user.attributes.email,
          taxYear: "2020",
          workFlowStatus: "new",
        };
        const newTaxReturn = await API.graphql(graphqlOperation(createTaxReturn, { input: input }));
        console.log("The new TaxReturn Created is:", newTaxReturn);
        setTaxReturn(newTaxReturn.data.createTaxReturn);
        return newTaxReturn;
      } catch (err) {
        console.error("Error registering new Tax Return", err);
      }
    } else {
      console.log("Tax Return Check: returnedObject", data.getTaxReturn);
      setTaxReturn(data.getTaxReturn);
    }
  }

  const handleSignout = async () => {
    try {
      //await Auth.signOut();
      //setUser(null);

      setSignOutState(true);

      if (!user.attributes.identities) {
        await Auth.signOut();
      } else {
        setUser(null);
        await Auth.federatedSignIn();
      }
    } catch (err) {
      console.error("Error signing out user", err);
    }
  };
  return (
    <div className={classes.root}>
      <AppBar position="static" color="inherit">
        <Toolbar>
          <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
            <MenuIcon />
          </IconButton>
          <img src={logo} alt="Mantra Tax" className={classes.logo} />
          <Typography variant="h6" className={classes.title}>
            Upload your Tax Return documents
          </Typography>
          <Button color="inherit" onClick={handleSignout}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
}
